import { Injectable, Type } from '@angular/core';
import { BaseApiService } from '@kinet-open-network/client/core/api-client';
import { AdditionalService } from '../models/additional-service.model';

@Injectable({
  providedIn: 'root',
})
export class AdditionalServicesService extends BaseApiService<AdditionalService> {
  override model: Type<AdditionalService> = AdditionalService;

  override get endpoint(): string {
    return '/additional-services';
  }
}

